import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as FilterResetIcon } from '@assets/svg/reset.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const ResetButton = ({ showResetButton, onClick }) => {
  const { t } = useTranslation();

  return showResetButton ? (
    <div className={style.resetFilter} onClick={onClick}>
      <FilterResetIcon id="resetFilter" className={style.resetIcon} />
      <Tooltip anchorSelect="#resetFilter" content={t('Reset Filters')} />
    </div>
  ) : null;
};

export default ResetButton;
